import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/library/Icon";
import styles from "./AbstractDropdownOption.css";

export default class AsyncDropdownOption extends React.Component {
  render() {
    const eventHandlers = {
      onMouseDown: event => {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.isDisabled) return;
        this.props.onSelect(this.props.option, event);
      },
      onMouseEnter: event => {
        this.props.onFocus(this.props.option, event);
      },
      onMouseMove: event => {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
      },
    };

    const NameComponent = this.props.nameComponent;

    return (
      <div
        className={classNames(styles.root, {
          [styles.isFocused]: this.props.isFocused,
          [styles.isDisabled]: this.props.isDisabled,
          [styles.isSelected]: this.props.isSelected,
        })}
        {...eventHandlers}
      >
        <NameComponent
          option={this.props.option}
          className={styles.nameComponent}
        />
        {this.props.isSelected ? (
          <Icon name="check/square" className={styles.icon} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

AsyncDropdownOption.defaultProps = {
  nameComponent: ({ option }) => option.name,
};

AsyncDropdownOption.propTypes = {
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.object.isRequired,
  nameComponent: PropTypes.func,
};
